import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: "/", label: "Home" },
    { to: "/features", label: "Features" },
    { to: "/docs", label: "API Docs" },
    // { to: "/pricing", label: "Pricing" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img
              src="/zindilogo.png"
              alt="ZINDI Logo"
              className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-10">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`text-base xl:text-lg font-medium transition-all relative group ${
                  location.pathname === l.to ? "text-primary" : "text-gray-700"
                }`}
              >
                {l.label}
                <span
                  className={`absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-primary to-accent transform origin-left transition-transform ${
                    location.pathname === l.to
                      ? "scale-x-100"
                      : "scale-x-0 group-hover:scale-x-100"
                  }`}
                />
              </Link>
            ))}
            <Link
              to="/portal"
              className="bg-gradient-to-r from-primary to-accent text-white px-6 xl:px-8 py-2.5 xl:py-3 rounded-xl font-bold hover:shadow-2xl hover:scale-105 transition-all"
            >
              Merchant Portal
            </Link>
          </div>

          {/* Mobile Button */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2"
            aria-label="Toggle menu"
          >
            <svg
              className="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d={mobileOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
              />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="lg:hidden py-6 border-t border-gray-200">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setMobileOpen(false)}
                className="block py-4 text-lg font-medium text-gray-700 hover:text-primary hover:bg-blue-50 px-4 rounded-lg"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/portal"
              onClick={() => setMobileOpen(false)}
              className="block mt-4 bg-gradient-to-r from-primary to-accent text-white text-center py-4 rounded-xl font-bold hover:shadow-2xl hover:scale-105 transition-all"
            >
              Merchant Portal
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}